import type { Nullable } from '@iheartjane/types';

import { Breadcrumbs } from '@jane/bloom/components/breadcrumbs/breadcrumbs';
import type { Breadcrumb } from '@jane/bloom/types/schemas/bloom/breadcrumb';
import { titleCase } from '@jane/bloom/utils/strings/titleCase';

interface ProductTitleBreadcrumbsProps {
  category: Nullable<string>;
  className?: string;
  name: string;
}

export function ProductTitleBreadcrumbs({
  category,
  className,
  name,
}: ProductTitleBreadcrumbsProps) {
  const breadcrumbs: Breadcrumb[] = [
    {
      label: 'Home',
      to: '/',
    },
  ];

  if (category) {
    breadcrumbs.push({
      label: titleCase(category),
      to: `/${category}`,
    });
  }
  breadcrumbs.push({
    label: titleCase(name),
  });

  return <Breadcrumbs className={className} breadcrumbs={breadcrumbs} />;
}
